import React from 'react';

const CustomSelect = ({ options, label, limit, setLimit, setRefetch, loading }) => {
  const handleChange = (e) => {
    setLimit(+e.target.value);
    setRefetch((prevState) => !prevState);
  };

  return (
    <select onChange={handleChange} disabled={loading} defaultValue={limit} required>
      {options.map((option) => {
        return (
          <option value={option} key={option}>
            {option} {label}
          </option>
        );
      })}
    </select>
  );
};

export default CustomSelect;
